var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 433,
    viewBox: "0 0 301 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.6766 216.275C85.6766 216.275 66.3807 137.698 6.82557 103.577C-52.7296 69.4568 -129.992 92.7141 -129.992 92.7141C-129.992 92.7141 -110.697 171.291 -51.1414 205.411C8.41382 239.532 85.6766 216.275 85.6766 216.275Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5418 216.584C84.5418 216.584 61.2318 139.103 95.1863 79.4536C129.141 19.8037 207.503 0.57349 207.503 0.57349C207.503 0.57349 230.813 78.0538 196.858 137.704C162.904 197.354 84.5418 216.584 84.5418 216.584Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6836 216.3C85.6836 216.3 108.994 293.781 75.0391 353.431C41.0846 413.081 -37.2771 432.311 -37.2771 432.311C-37.2771 432.311 -60.5875 354.831 -26.6329 295.181C7.32161 235.531 85.6836 216.3 85.6836 216.3Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5488 216.61C84.5488 216.61 103.845 295.187 163.4 329.308C222.955 363.428 300.217 340.171 300.217 340.171C300.217 340.171 280.922 261.594 221.367 227.474C161.812 193.353 84.5488 216.61 84.5488 216.61Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.780b5868531fd8312309750c82149e3a.svg";
export { ForwardRef as ReactComponent };